import z from 'zod';

const verificationSchema = z.object({
  phone: z.boolean(),
  email: z.boolean(),
});

const userSchema = z.object({
  name: z.string().min(1),
  registrationDate: z.string(),
  verification: verificationSchema,
});

type UserProfile = z.infer<typeof userSchema>;

export { userSchema, type UserProfile };
